import { render, staticRenderFns } from "./PromotionPagination.vue?vue&type=template&id=71a82e1e&"
import script from "./PromotionPagination.vue?vue&type=script&lang=js&"
export * from "./PromotionPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports